import { z } from 'zod';
import { ExportScheduleFrequency } from '@mews-commander/data-access';
import { dateTimeUtcStringSchema } from '@mews/framework';

export enum ScheduleValueKey {
    name = 'name',
    nextStart = 'nextStart',
    frequency = 'frequency',
    notifyCreatorAboutExport = 'notifyCreatorAboutExport',
    isActive = 'isActive',
    exportTargetIds = 'exportTargetIds',
}

export const scheduleSchema = z.object({
    [ScheduleValueKey.name]: z.string().trim().min(1),
    [ScheduleValueKey.nextStart]: dateTimeUtcStringSchema,
    [ScheduleValueKey.frequency]: z.nativeEnum(ExportScheduleFrequency),
    [ScheduleValueKey.notifyCreatorAboutExport]: z.boolean(),
    [ScheduleValueKey.isActive]: z.boolean(),
    [ScheduleValueKey.exportTargetIds]: z.array(z.string()).nullable(),
});

export type ScheduleValues = z.infer<typeof scheduleSchema>;
